import { AnyAction } from "redux";
import { IAgenciesState } from "../interfaces";
import { Agency, Jog } from "../states/agency";
import { types } from "../../actions/types";
import { AgencyAdminStoreError, AgencyAdminStoreSuccess } from "../../enums/store-messages/admin";

export const initialAgenciesState: IAgenciesState = {
  agencyIds: [],
  agenciesById: {},
  jogsById: {},
  jogIds: [],
  successMessage: "",
  failureMessage: "",
};

function agencyReducer(state = initialAgenciesState, action: AnyAction): IAgenciesState {
  switch (action.type) {
    // GET agencies
    case types.GET_AGENCIES:
      return {
        ...state,
        successMessage: "",
        failureMessage: "",
      }
    case types.GET_AGENCIES_SUCCESS:
      const agenciesById = Object.fromEntries(
        action.payload.agencies.map((a: Agency) => [a.id, a])
      );
      const agencyIds = action.payload.agencies.map((a: Agency) => a.id);      
      
      const jogsById = Object.fromEntries(
        action.payload.jogs.map((j: Jog) => [j.id, j])
      );
      const jogIds = action.payload.jogs.map((j: Jog) => j.id);
      
      return {
        ...state,
        agenciesById,
        agencyIds,
        jogsById,
        jogIds,
        successMessage: "",
        failureMessage: "",
      }
    case types.GET_AGENCIES_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: AgencyAdminStoreError.GET_AGENCIES_ERROR,
      };
    // CREATE agency
    case types.CREATE_AGENCY:
      return {
        ...state,
        successMessage: "",
        failureMessage: "",
      }
    case types.CREATE_AGENCY_SUCCESS:
      // todo: jcavner: Once action payload includes created agency object, add it to agency state
      return {
        ...state,
        successMessage: AgencyAdminStoreSuccess.CREATE_AGENCY_SUCCESS,
        failureMessage: "",
      }
    case types.CREATE_AGENCY_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: AgencyAdminStoreError.CREATE_AGENCY_ERROR,
      }
    // UPDATE agency
    case types.UPDATE_AGENCY:
      return {
        ...state,
        successMessage: "",
        failureMessage: "",
      }
    case types.UPDATE_AGENCY_SUCCESS:
      // todo: jcavner: Once action payload includes updated agency object, replace the old object with new object in agency state
      return {
        ...state,
        successMessage: AgencyAdminStoreSuccess.UPDATE_AGENCY_SUCCESS,
        failureMessage: "",
      };
    case types.UPDATE_AGENCY_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: AgencyAdminStoreError.UPDATE_AGENCY_ERROR,
      };
    default:
      return state;
  }
}

export default agencyReducer;